export const type = {
  changeOpen: '[MenuState] SET_OPEN',
};
